import React, { useEffect, useState } from 'react'
import Dialog from '@material-ui/core/Dialog'
import DialogContent from '@material-ui/core/DialogContent'
import Grid from '@material-ui/core/Grid'
import Box from '@material-ui/core/Box'
import Typography from '@material-ui/core/Typography'
import ProviderAPI from 'config/api/ProviderAPI'
import { onError } from 'config/lib/errorLib'
import Loader from 'components/general/Loader'
import { Elements } from '@stripe/react-stripe-js'
import CardElement from 'components/provider/CardElement'
import { loadStripe } from '@stripe/stripe-js'
import config from 'config/api/Config'
import getLeadPrice from 'config/helpers/leadPricing'

const stripePromise = loadStripe(config.stripeKey)

// PaymentForm removed; using shared CardElement in payment mode

export default function PaymentModal({ open, onClose, companyDetails, leadCount = 40, onSuccess }) {
    const [clientSecret, setClientSecret] = useState(null)
    const [loading, setLoading] = useState(true)
    // Pre-calculate total (VAT inclusive) using dynamic lead price
    const countyCount = (companyDetails.counties || []).length;
    const coverageType = (companyDetails.coverageType || 'counties').toLowerCase();
    const leadPrice = getLeadPrice(coverageType, countyCount);
    const total = (leadCount * leadPrice * 1.23).toFixed(2)

    useEffect(() => {
        if (!open) return
        let isMounted = true
        async function init() {
            try {
                const api = new ProviderAPI()
                const secret = await api.getPaymentIntent(companyDetails.companyId, total, 'newPaymentMethod')
                console.log('payment intent: ', secret)
                if (isMounted) setClientSecret(secret)
            } catch (e) {
                onError(e)
            }
            if (isMounted) setLoading(false)
        }
        init()
        return () => { isMounted = false }
    }, [open, companyDetails.companyId, leadCount])

    // Confirm top-up on backend & increment balance
    async function handlePaymentSuccess(paymentIntentId) {
        try {
            const api = new ProviderAPI()
            await api.confirmTopup(companyDetails.companyId, paymentIntentId, total)
            onSuccess && onSuccess(paymentIntentId)
        } catch (e) {
            onError(e)
        }
    }

    return (
        <Dialog open={open} onClose={onClose} maxWidth='sm' fullWidth>
            <DialogContent>
                <Grid container spacing={2}>
                    <Grid item xs={12} style={{ marginBottom: '0.5rem' }}>
                        <Box component={Typography} variant='h3'>
                            <Box component='span'>Account Topup</Box>
                        </Box>
                    </Grid>
                    <Grid item xs={12}>
                        <Typography variant='body2'>
                            One-off top-up purchase of {leadCount} verified leads. Your card will be charged immediately. Leads will be delivered until your balance reaches zero.
                        </Typography>
                    </Grid>
                    {loading ? (
                        <Grid item xs={12}>
                            <Box display='flex' justifyContent='center' alignItems='center' style={{ height: '15vh' }}>
                                <Loader />
                            </Box>
                        </Grid>
                    ) : clientSecret ? (
                        <Grid item xs={12}>
                            <Elements stripe={stripePromise} options={{ clientSecret }}>
                                <CardElement
                                    clientSecret={clientSecret}
                                    mode='payment'
                                    cardOnly={true}
                                    onSuccess={handlePaymentSuccess}
                                />
                            </Elements>
                        </Grid>
                    ) : (
                        <Grid item xs={12}>
                            <Typography variant='body2' style={{ color: 'red' }}>Unable to initialize payment. Please refresh.</Typography>
                        </Grid>
                    )}
                </Grid>
            </DialogContent>
        </Dialog>
    )
}